export const blockImageUploadStatuses = { idle: 'idle', loading: 'loading', error: 'error' }

export const blockImageSettingKey = 'image_url'
